import styled from 'styled-components';

export const MultiplePrewievStyles = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  & img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const MultipleContainer = styled.div`
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
`;

export const MultipleItem = styled.div`
  flex: 1;
  display: flex;
  width: 100%;
  cursor: pointer;
`;

export const Pointer = styled.div`
  z-index: 1;
  flex-grow: 1;
  height: 3px;
  background-color: white;
  margin: 5px 2px;
  align-self: flex-end;

  &.active {
    background-color: ${({ theme }) => theme.colors.color_blue};
  }
`;

export const LastMessage = styled.div`
  display: none;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
  justify-content: center;
  align-items: center;

  &.show {
    display: flex;
  }
`;
